import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, ShieldCheck, ShieldOff, Maximize2 } from "lucide-react";
import { TothChat } from "@/components/toth/TothChat";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { api } from "@/lib/api";
import { fmtDT } from "@/lib/format";

function contextFromPath(path) {
  if (path.startsWith("/ordini/")) return "Ordine di lavoro aperto";
  if (path.startsWith("/criticita/")) return "Criticità aperta";
  if (path.startsWith("/mezzi/")) return "Scheda mezzo";
  if (path.startsWith("/commesse/")) return "Scheda commessa";
  if (path.startsWith("/ordini")) return "Elenco ordini";
  if (path === "/") return "Dashboard";
  return "Sezione corrente";
}

export const TothPanel = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const loc = useLocation();

  useEffect(() => {
    if (open) api.get("/toth/status").then((r) => setStatus(r.data)).catch(() => {});
  }, [open]);

  return (
    <>
      <button data-testid="toth-fab-button" onClick={() => setOpen(true)}
        className="fixed bottom-24 right-4 z-40 flex h-14 items-center gap-2 rounded-full brand-gradient px-5 font-bold text-white shadow-lg shadow-lime-900/20 tile-press lg:bottom-6 lg:right-6">
        <Sparkles className="h-5 w-5" /> Toth
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent aria-describedby={undefined} data-testid="toth-panel" className="flex w-full flex-col gap-0 p-0 sm:max-w-lg">
          <SheetHeader className="border-b px-4 pb-3 pt-5 text-left">
            <SheetTitle className="flex items-center gap-2 text-xl font-extrabold"><Sparkles className="h-5 w-5 text-primary" /> Toth</SheetTitle>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground" data-testid="toth-panel-status">
              <span className="flex items-center gap-1 font-semibold">{status?.toth_enabled ? <ShieldCheck className="h-3.5 w-3.5 text-emerald-600" /> : <ShieldOff className="h-3.5 w-3.5 text-red-600" />}{status ? (status.toth_enabled ? "Attivo" : "Disattivato") : "…"}</span>
              <span data-testid="toth-panel-context">Contesto: {contextFromPath(loc.pathname)}</span>
              <span>Motore: {fmtDT(status?.last_engine_run?.at)}</span>
              <Link to="/toth" onClick={() => setOpen(false)} className="ml-auto flex items-center gap-1 font-semibold text-primary" data-testid="toth-panel-open-page"><Maximize2 className="h-3.5 w-3.5" />Apri Toth</Link>
            </div>
          </SheetHeader>
          <div className="min-h-0 flex-1">{open && <TothChat compact contextPath={loc.pathname} />}</div>
        </SheetContent>
      </Sheet>
    </>
  );
};
